const html = document.querySelector('html');
const isMsBrowser = html.classList.contains('ms');
const toggles = Array.from(document.querySelectorAll('[data-toggle-navigation]'));
const body = document.querySelector('body');
const scrollbar = window.innerWidth - body.offsetWidth;
const rtl = (document.querySelector('html').getAttribute('dir') == 'rtl');
const nav = document.querySelector('.navigation');


let scrollSide = (rtl && html.classList.contains('ms')) ? 'left' : 'right';

function toggleNavigation (event) {
  event.preventDefault();
  window.requestAnimationFrame(() => {
    body.classList.toggle('show-nav');

    if(rtl && !isMsBrowser) return;

    // setting body border replacing scrollbar to avoid horizontal jump
    if (window.innerWidth - body.offsetWidth == 0 && body.classList.contains('show-nav')) {
      body.style.cssText = `border-${scrollSide}: ${scrollbar}px solid transparent`;
    } else {
      body.style.cssText = `border-${scrollSide}: 0px`;
    }
  })
}

function initNav() {
  if(!toggles) return;
  toggles.forEach((elem) => {
    elem.addEventListener('click', toggleNavigation);
  })
  body.addEventListener('click', (event) => {
    if(event.target == body && body.classList.contains('show-nav')) {
      toggleNavigation(event);
    };
  })
  $('.navigation .root > li:not(.active)').hover(
    function() {
      window.requestAnimationFrame(() => {
        $(nav).toggleClass('browsing');
      })
    }
  )
}

export default initNav



// WEBPACK FOOTER //
// ./public/javascripts/modules/navigation.js